import { NO_VALUE_DISPLAY } from "../constants";
import { INotificationDto, SupportedLanguage } from "../models";

export const resolveNotificationContent = (
  notificationContent: INotificationDto["content"],
  language: SupportedLanguage,
): string => {
  const generalContent = notificationContent.find(
    ({ type }) => type === "GENERAL",
  );

  if (!generalContent) {
    return NO_VALUE_DISPLAY;
  }

  const localisedTextObject = generalContent.localisedTexts.find(
    ({ lang }) => lang === language,
  );

  if (!localisedTextObject) {
    const enTextObject = generalContent.localisedTexts.find(
      ({ lang }) => lang === "en",
    );

    if (!enTextObject) {
      return NO_VALUE_DISPLAY;
    }

    return enTextObject.text;
  }

  return localisedTextObject.text;
};
